import { render } from "./UsersView.vue?vue&type=template&id=642216fe&scoped=true"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"

import "./UsersView.vue?vue&type=style&index=0&id=642216fe&scoped=true&lang=css"
import "./UsersView.vue?vue&type=style&index=1&id=642216fe&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642216fe"]])

export default __exports__